import { registerModal } from 'features/Modal/ModalRegistry'
import CasesCreateEnquiryModal from './CasesCreateEnquiryModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'CASES_CREATE_ENQUIRY'
registerModal(modalType, CasesCreateEnquiryModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateEnquiryModal/CasesCreateEnquiryModal.action.js